import { render } from "./Rent_process_button.vue?vue&type=template&id=2533aef6&scoped=true"
import script from "./Rent_process_button.vue?vue&type=script&lang=js"
export * from "./Rent_process_button.vue?vue&type=script&lang=js"

import "./Rent_process_button.vue?vue&type=style&index=0&id=2533aef6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2533aef6"]])

export default __exports__